<template>
  <div class="hierarchy-item">
    <div class="request-item-container" :class="{ 'shadow-md': isPrimary }">
      <div class="flex w-full">
        <div class="flex flex-col flex-1 min-w-0 -mx-2">
          <MTooltip placement="topLeft">
            <template v-slot:trigger>
              <a
                target="__blank"
                :href="
                  $router.resolve(
                    $modules.getModuleRoute('ticket', 'view', {
                      params: { id: request.id, ticketType: moduleName },
                    })
                  ).href
                "
                :style="{ maxWidth: '80%' }"
              >
                <h5 class="subject-title font-normal text-ellipsis pl-2">
                  {{ request.name ? `${request.name} : ` : '' }}
                  {{ request.subject }}
                </h5>
              </a>
            </template>
            {{ request.name ? `${request.name} : ` : '' }}
            {{ request.subject }}
          </MTooltip>
          <small class="text-neutral-light pl-2">
            {{ request.requesterData.name || request.requesterData.email }},
            {{ request.createdAt | datetime }}
          </small>
        </div>
        <div class="flex justify-end actions bg-white">
          <slot name="actions" />
        </div>
      </div>

      <div class="flex mt-2">
        <MRow :gutter="0" :size="12" class="flex w-full">
          <MCol id="status-picker" :size="6">
            <FlotoStatusPicker :value="request.statusId" module-name="request">
              <template v-slot:trigger="slotData">
                <FlotoDropdownTrigger
                  v-bind="slotData"
                  :lable="$t('status')"
                  icon-name="vector"
                  custom-icon
                  disabled
                />
              </template>
            </FlotoStatusPicker>
          </MCol>
          <MCol id="priority-picker" :size="6">
            <FlotoPriorityPicker
              :value="request.priorityId"
              module-name="request"
            >
              <template v-slot:trigger="slotData">
                <FlotoDropdownTrigger
                  v-bind="slotData"
                  :lable="$t('priority')"
                  icon-name="priority"
                  custom-icon
                  disabled
                />
              </template>
            </FlotoPriorityPicker>
          </MCol>
        </MRow>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RequestItem',
  props: {
    request: { type: Object, required: true },
    isPrimary: { type: Boolean, default: false },
    moduleName: { type: String, required: true },
  },
}
</script>

<style lang="less" scoped>
.request-item-container {
  padding: 12px;
  background: var(--page-background-color);
  border: 1px solid var(--border-color);
  border-radius: 4px;

  .actions {
    top: 0;
    background-color: unset;
  }
  // &:hover {
  //   .actions {
  //     opacity: 1;
  //   }
  // }
}
</style>
